export async function isShabbatNow(): Promise<boolean> {
  try {
    const res = await fetch(
      "https://www.hebcal.com/shabbat?cfg=json&geonameid=293397&M=on"
    );

    const data = await res.json();

    const candleLighting = new Date(
      data.items.find((i: any) => i.category === "candles").date
    );

    const havdalah = new Date(
      data.items.find((i: any) => i.category === "havdalah").date
    );

    const now = new Date();

    return now >= candleLighting && now <= havdalah;
  } catch (error) {
    console.error("Failed to check Shabbat:", error);
    return false;
  }
}
